import React, { useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import { NB } from '@cerebral-inc/ui';
import { getStaticFilePath } from 'components/shared/utils';
import {
  CarouselContainer,
  InnerContainer,
  CarouselItem as CarouselItemWrapper,
  Indicators,
  IndicatorDot,
  ArrowLeft,
  ArrowRight,
  IndicatorWrapper
} from './styled';
import leftArrow from '../images/left-arrow.svg';
import rightArrow from '../images/right-arrow.svg';
import { CarouseProps, CarouselItemProps } from './types';
import { defaultIndicatorStyles } from './constants';

const { Image } = NB;

export const CarouselItem = ({ children }: CarouselItemProps): JSX.Element => {
  return <CarouselItemWrapper>{children}</CarouselItemWrapper>;
};

export const Carousel = ({
  children,
  indicatorStyles = defaultIndicatorStyles,
  startingIndex = 0
}: CarouseProps): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState(startingIndex);

  const updateIndex = (index: number) => {
    let newIndex = index;
    if (newIndex < 0) {
      newIndex = React.Children.count(children) - 1;
    } else if (newIndex >= React.Children.count(children)) {
      newIndex = 0;
    }

    setActiveIndex(newIndex);
  };

  const handlers = useSwipeable({
    onSwipedLeft: () => updateIndex(activeIndex + 1),
    onSwipedRight: () => updateIndex(activeIndex - 1)
  });

  return (
    <CarouselContainer {...handlers} style={{ position: 'relative' }}>
      <InnerContainer
        style={{ transform: `translateX(-${activeIndex * 33.333}%)` }}
      >
        {children}
      </InnerContainer>
      <ArrowLeft
        desktop={indicatorStyles.desktop}
        mobile={indicatorStyles.mobile}
        onClick={() => {
          updateIndex(
            activeIndex === 0
              ? React.Children.toArray(children).length - 1
              : activeIndex - 1
          );
        }}
      >
        <Image
          alt="see previous"
          src={getStaticFilePath(leftArrow)}
          w="32px"
          h="32px"
        />
      </ArrowLeft>
      <ArrowRight
        desktop={indicatorStyles.desktop}
        mobile={indicatorStyles.mobile}
        onClick={() => {
          updateIndex(
            activeIndex === React.Children.toArray(children).length - 1
              ? 0
              : activeIndex + 1
          );
        }}
      >
        <Image
          alt="see next"
          src={getStaticFilePath(rightArrow)}
          w="32px"
          h="32px"
        />
      </ArrowRight>
      <IndicatorWrapper>
        <ArrowLeft
          onClick={() => {
            updateIndex(
              activeIndex === 0
                ? React.Children.toArray(children).length - 1
                : activeIndex - 1
            );
          }}
        >
          <Image
            alt="see previous"
            src={getStaticFilePath(leftArrow)}
            w="32px"
            h="32px"
          />
        </ArrowLeft>
        <Indicators>
          {React.Children.map(children, (item, index) => {
            return (
              <IndicatorDot
                key={`${item}`}
                is_active={(index === activeIndex).toString()}
              />
            );
          })}
        </Indicators>
        <ArrowRight
          onClick={() => {
            updateIndex(
              activeIndex === React.Children.toArray(children).length - 1
                ? 0
                : activeIndex + 1
            );
          }}
        >
          <Image
            alt="see next"
            src={getStaticFilePath(rightArrow)}
            w="32px"
            h="32px"
          />
        </ArrowRight>
      </IndicatorWrapper>
    </CarouselContainer>
  );
};
